"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ButtonContainer = styled_components_1.default.div `
  text-align: right;
  padding-top: 10px;

  > button {
    margin-left: 5px;
  }
`;
//# sourceMappingURL=button-container.js.map